export default __webpack_public_path__ + "static/media/yen-and-max.eb66c765.jpg";